<template>
	<div id="auth_page" style="width: 100%;background-color:e60012;">
			<img src="/img/authpage.jpg" width="100%"/>
			<div style="position: absolute;bottom: 3rem;width: 100px;text-align: center;left:50%;margin-left: -50px;background: rgba(0, 0, 0, 0.3);border-radius: 1.239994rem;color:#FFFFFF;">授权中</div>
			</div>
</template>

<script>
		export default {
		data () {
		  return {
		    value: ''
		  }
		},
		mounted(){
			//document.getElementById("auth_page").style.height=document.documentElement.clientHeight+"px";
			//console.log(document.getElementById("auth_page").style.height);
			if(!this.$cookies.isKey("user_token")||this.$cookies.get("user_token")==undefined){
					location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxcccc461820b4dfad&redirect_uri=http%3a%2f%2fweixin.huazhi.cn%2fgetauthcode&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
			}
			else{
				this.$router.push('/usercenter');
			}
		},
	}
</script>

<style>
</style>
